import { useClickAway } from '@ipfabric/ui-components/hooks/useClickAway';
import type { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  id?: string;
  open: boolean;
  toggle: () => void;
  dataTestId?: string;
}

export const ClickOutsideDropdownHandler: FC<Props> = (props) => {
  const ref = useClickAway<HTMLLIElement>(() => {
    if (props.open) {
      props.toggle();
    }
  });

  return (
    <li
      className={props.className}
      ref={ref}
      id={props.id}
      data-testid={props.dataTestId}
    >
      {props.children}
    </li>
  );
};
